import React from "react";

const Dashboard = () => {
  return (
    <div className="min-h-screen px-4 py-8">
      <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800 shadow-lg rounded-2xl p-8">
        <h1 className="text-3xl font-bold mb-4 text-gray-800 dark:text-white">
          Welcome to the Dashboard Page!
        </h1>
        <p className="text-gray-600 dark:text-gray-300">
          You are now logged in 🎉. Explore your dashboard using the sidebar!
        </p>
      </div>
    </div>
  );
};

export default Dashboard;
